import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import { toggleModal } from '../../../reducers/modalReducer'
import { useDispatch } from 'react-redux';

const KeyFeatureSeeMoreModal = ({ selectedSeeMore }) => {
    const dispatch = useDispatch();
    return (
        <>
            <ModalWrapper id="keyFeatureSeeMore" modalType={'seeMorePopupNew'} modalCardClasses='maw1300px' >
                {selectedSeeMore &&
                    <div className='df w100' >
                        <div style={{ width: "55%", height: '100%' }}>
                            <div className='df w100 mb1rem'>
                                <div className="w10 df aic">{selectedSeeMore?.icon}</div>
                                <div className="w90 fw500 c15 pl1rem df aic" style={{ fontSize: '26px', lineHeight: '37.32px' }}>{selectedSeeMore?.title}</div>
                            </div>
                            {/* custom-list */}
                            <ul className=" mt0-5rem" style={{ paddingLeft: '22px' }}>
                                {selectedSeeMore?.points?.map((objpoints, index) => {
                                    return (
                                        <li style={{ lineHeight: '25px', paddingBottom: "3px", paddingTop: "3px", paddingLeft: "20px", borderLeft: '2px solid #D3D9FC' }} className="df fdc fs1rem c14 fs1rem fw400" key={`${objpoints}-${index}`}>
                                            <div className="pr">
                                                <div className="circle"></div>
                                                {objpoints}
                                            </div>
                                            <div>{selectedSeeMore?.subMenu && selectedSeeMore?.subMenu?.index == index &&
                                                selectedSeeMore?.subMenu?.points?.map((str, i, arr) => {
                                                    return (
                                                        <div className="fs1rem c14 fs1rem fw400 df aic pl2rem" style={{ lineHeight: '30px' }}>{str}</div>
                                                    )
                                                })
                                            }
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul >
                            {selectedSeeMore?.notePoint &&
                                <div className="mt1rem" style={{ border: '1px solid gray', padding: "10px", borderRadius: '10px' }}>{selectedSeeMore?.notePoint}</div>
                            }
                        </div>
                        <div className="df aic jce" style={{ width: '45%' }}>
                            <img src={selectedSeeMore?.image} className="w70" style={{ objectFit: 'fill' }} />
                            {selectedSeeMore?.['isStoryVideo'] && <img src={require('../../../../images/videoButton.png')} onClick={() => dispatch(toggleModal({ open: "videoCompanies" }))} className='pa cp zi1' style={{ right: '10%', bottom: '10px' }} />}
                        </div>
                    </div>
                }

            </ModalWrapper>

        </>
    )
}

export default KeyFeatureSeeMoreModal